import React from 'react';
import { ClinicalButton } from './ui';

/**
 * Footer fixe — identité patient à gauche, actions à droite.
 */
export default function ConsultationEditorPageFooter({
  identityTargetRef,
  formId,
  readOnly = false,
  loading = false,
  isEdit = false,
  isPendingConsultation = false,
  formDisabled = false,
  onCancel,
  onSaveDraft,
  onComplete
}) {
  return (
    <footer className="consult-editor-page-shell__footer hd-no-print" aria-label="Pied de page consultation">
      <div className="consult-editor-page-shell__footer-inner">
        <div ref={identityTargetRef} className="consult-editor-page-shell__footer-identity" />

        <div className="consult-editor-page-shell__footer-actions">
          <ClinicalButton variant="secondary" size="md" type="button" onClick={onCancel} disabled={loading}>
            <span className="consult-footer-btn__long">{readOnly ? 'Retour à la liste' : 'Annuler · retour liste'}</span>
            <span className="consult-footer-btn__short">{readOnly ? 'Retour' : 'Annuler'}</span>
          </ClinicalButton>
          {!readOnly ? (
            <>
              {isPendingConsultation && isEdit ? (
                <ClinicalButton
                  variant="secondary"
                  size="md"
                  type="button"
                  loading={loading}
                  disabled={formDisabled}
                  onClick={onSaveDraft}
                >
                  <span className="consult-footer-btn__long">Enregistrer le brouillon</span>
                  <span className="consult-footer-btn__short">Brouillon</span>
                </ClinicalButton>
              ) : null}
              <ClinicalButton
                variant="primary"
                size="md"
                type={isPendingConsultation && isEdit ? 'button' : 'submit'}
                form={isPendingConsultation && isEdit ? undefined : formId}
                loading={loading}
                disabled={formDisabled}
                onClick={isPendingConsultation && isEdit ? onComplete : undefined}
              >
                {isEdit ? (
                  isPendingConsultation ? (
                    <>
                      <span className="consult-footer-btn__long">Terminer la consultation</span>
                      <span className="consult-footer-btn__short">Terminer</span>
                    </>
                  ) : (
                    <>
                      <span className="consult-footer-btn__long">Enregistrer les modifications</span>
                      <span className="consult-footer-btn__short">Enregistrer</span>
                    </>
                  )
                ) : (
                  <>
                    <span className="consult-footer-btn__long">Créer la consultation</span>
                    <span className="consult-footer-btn__short">Créer</span>
                  </>
                )}
              </ClinicalButton>
            </>
          ) : null}
        </div>
      </div>
    </footer>
  );
}
